import React from 'react'
import styled from 'styled-components'

interface Props {
  status?: string | boolean | null
}

const normalize = (value?: string | boolean | null) => {
  if (typeof value === 'boolean') {
    return value ? 'active' : 'inactive'
  }
  return (value || 'unknown').toString().toLowerCase()
}

const toneMap: Record<string, { background: string; color: string }> = {
  active: { background: '#e7f8ee', color: '#127a46' },
  inactive: { background: '#f3f4f6', color: '#4b5563' },
  draft: { background: '#fff6db', color: '#9a6700' },
  posted: { background: '#e7f8ee', color: '#127a46' },
  reversed: { background: '#fdecec', color: '#b42318' },
  paid: { background: '#e7f8ee', color: '#127a46' },
  approved: { background: '#e7f8ee', color: '#127a46' },
  submitted: { background: '#eef4ff', color: '#1d4ed8' },
  refused: { background: '#fdecec', color: '#b42318' },
  open: { background: '#e7f8ee', color: '#127a46' },
  soft_closed: { background: '#fff6db', color: '#9a6700' },
  hard_closed: { background: '#fdecec', color: '#b42318' },
}

const Badge = styled.span<{ tone: { background: string; color: string } }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) => props.tone.background};
  color: ${(props) => props.tone.color};
  text-transform: capitalize;
`

const FinanceStatusBadge: React.FC<Props> = ({ status }) => {
  const normalized = normalize(status)
  const tone = toneMap[normalized] || {
    background: '#eef2ff',
    color: '#4338ca',
  }

  const label = normalized.replaceAll('_', ' ')
  return (
    <Badge tone={tone}>{label.charAt(0).toUpperCase() + label.slice(1)}</Badge>
  )
}

export default FinanceStatusBadge
